// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"c4b73d32","61":"23f9a197","298":"0fb84e9a","564":"e5cdbd5d","686":"cd2f32ca","893":"d0c4d8ba"}[chunkId] + ".chunk.js";
};